<section class="section_one" >
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="state__sec">
                    <ul class="state__list" *ngFor="let data of data1 | filter:searchkey:'buildingName' ">
                        <li>
                            <div class="statelist__flex">
                                <div class="statetitle__flex">
                                    <div>
                                        <h5 class="state__name">{{data.buildingName}}
                                        </h5>
                                    </div>
                                    <div>
                                        <h6 class="state__dvrs">DVR Checked: <span
                                                class="state__dvrs">{{data.dvrCheckDate}}</span>
                                        </h6>
                                    </div>
                                </div>
                                <div class="main-container">
                                    <!-- <mat-expansion-panel> -->
                                        <!-- <mat-expansion-panel-header>  -->
                                    <div class="card-head" id="headingOne">
                                        <div class="statelist__flexx collapsed" data-toggle="collapse"
                                            data-target="#collapseOne" aria-expanded="false"
                                            aria-controls="collapseOne">
                                            <div class="cctv__collapse">
                                                <div class="back1">
                                                    <button class="btn btn-primary back" (click)="backside()"><span>
                                                            <img src="../../assets/image/ic_outline-arrow-back.svg"
                                                                alt="arrow back">
                                                        </span>Back</button>
                                                </div>
                                                <div class="dvr__border__right">
                                                    <h6 class="state__dvr">Total DVR:<span
                                                            class="dvr__color"></span>{{data.totalDvrs}}</h6>
                                                </div>

                                                <div>
                                                    <h6 class="cctv__title">CCTV Installed</h6>
                                                    <h5 class="cctv__number">
                                                        {{data.totalCamerasInstalled}}</h5>
                                                </div>
                                                <div>
                                                    <h6 class="cctv__title">Connected</h6>
                                                    <h5 class="cctv__number">{{data.totalConnected}}
                                                    </h5>
                                                </div>
                                                <div>
                                                    <h6 class="cctv__title">Not Connected</h6>
                                                    <h5 class="cctv__number">{{data.totalNotConnected}}
                                                    </h5>
                                                </div>
                                                <div>
                                                    <h6 class="cctv__title">Streaming</h6>
                                                    <h5 class="cctv__number">
                                                        {{data.totalVideoStreaming}}</h5>
                                                </div>
                                                <div>
                                                    <h6 class="cctv__title">No Video</h6>
                                                    <h5 class="cctv__number">
                                                        {{data.totalVideoNotStreaming}}
                                                    </h5>
                                                </div>
                                                <ng-container *ngIf="data.dvrPresentWorkingStatus=='CONNECTED'">
                                                    <div>
                                                        <h6 class="cctv__title">Working status</h6>
                                                        <h5 class="cctv__online">
                                                            ONLINE</h5>
                                                    </div>
                                                </ng-container>
                                                <ng-container *ngIf="data.dvrPresentWorkingStatus!='CONNECTED'">
                                                    <div>
                                                        <h6 class="cctv__title">Working status</h6>
                                                        <h5 class="cctv__offline">
                                                            OFFLINE</h5>
                                                    </div>
                                                </ng-container>
                                                <div>
                                                    <!-- <h3 class="view_all" (click)="openDialog(data)">View All</h3> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- </mat-expansion-panel-header> -->
                                    <div class="card-body">
                                        <div *ngIf="data?.active " class="det-details">
                                            <div>
                                                <mat-card class="example-card" *ngIf="data2?.cctvDetails">
                                                    <div class="name">
                                                        {{data2?.cctvDetails.buildingName}}
                                                    </div>
                                                    <mat-divider></mat-divider>
                                                    <div>
                                                        <div class="campus_dtl">
                                                            <h3 class="ip-addres">Ip Address</h3>
                                                            <h3 class="ip-number">{{data2?.cctvDetails.ipAddress}}</h3>
                                                        </div>
                                                        <div class="color_1">
                                                            <div class="campus_dtl">
                                                                <h3 class="dvr-model">Dvr Model Number</h3>
                                                                <h3 class="dvr-number">
                                                                    {{data2?.cctvDetails.dvrModelNumber}}</h3>
                                                            </div>
                                                        </div>
                                                        <div class="campus_dtl">
                                                            <h3 class="serial">Serial Number</h3>
                                                            <h3 class="serial-number">
                                                                {{data2?.cctvDetails.serialNumber}}</h3>
                                                        </div>
                                                        <div class="color_1">
                                                            <div class="campus_dtl">
                                                                <h3 class="rtsp">RTSP Port No</h3>
                                                                <h3 class="rtsp-no">{{data2?.cctvDetails.rtspPortNo}}
                                                                </h3>
                                                            </div>
                                                        </div>
                                                        <div class="campus_dtl">
                                                            <h3 class="channel">Max No Of Channels
                                                            </h3>
                                                            <h3 class="channel-number">
                                                                {{data2?.cctvDetails.maxNoOfChannels}}</h3>
                                                        </div>
                                                        <div class="color_1">
                                                            <div class="campus_dtl">
                                                                <h3 class="cameras-install">Total Cameras Installed</h3>
                                                                <h3 class="camera-number">
                                                                    {{data2?.cctvDetails.totalCamerasInstalled}}</h3>
                                                            </div>
                                                        </div>
                                                        <div class="campus_dtl">
                                                            <h3 class="dvr-working">DVR Present Working Status
                                                            </h3>
                                                            <h3 class="dvr-status">
                                                                {{data2?.cctvDetails.dvrPresentWorkingStatus}}</h3>
                                                        </div>
                                                        <div class="color_1">
                                                            <div class="campus_dtl">
                                                                <h3 class="remark">Remarks</h3>
                                                                <h3 class="remark-video">{{data2?.cctvDetails.remarks}}
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </mat-card>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="cctv_video">
                                                    <div class="cctv_video_show">
                                                        <ul class="video-image" *ngFor="let frame of data.cctvFrameURLList">
                                                            <li>
                                                                <div class="video_width">
                                                                    <button class="btn-1" (click)="openvideostreaming(frame)">
                                                                        <figure class="mb-0">
                                                                            <img [src]="frame.cctvFrameUrl" class="cctvimg"
                                                                                alt="cctvimg missing">
                                                                        </figure>
                                                                        <p class="cctv_camno">C
                                                                            :{{frame.channelsNo}}
                                                                        </p>
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                              
                                            </div>
                                        </div>
                                    </div>
                                    <!-- </mat-expansion-panel> -->
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>